import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

import { HotkeyOptions } from 'angular2-hotkeys';
import { userServiceProvider } from './services/user.service';
import { authorizerServiceProvider } from './services/authorizer.service';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { billServiceProvider } from './services/bill.service';
// import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    environment.production ? BrowserAnimationsModule : NoopAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MatDialogModule,
    MatSnackBarModule,
    RouterModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js',
    {
      enabled: (environment.production && environment.name !== 'electron' && environment.name !== 'cordova'),
      registrationStrategy: "registerImmediately"
    })
  ],
  providers: [
    userServiceProvider,
    billServiceProvider,
    authorizerServiceProvider,
    { provide: HotkeyOptions, useValue: {} },
    DatePipe,
  ],
  // bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  ngDoBootstrap(app) {
    const options = {
      'app-root': AppComponent
    };
    let name = '';
    name = 'app-root';
    const componentElement = document.createElement(name);
    document.body.appendChild(componentElement);

    const component = options[name];
    app.bootstrap(component);
  }
}
